import { SortingRule } from 'react-table';
import * as DT from '../datatable';
import { State, FilterCriteria, Order } from './model';
import { getPK } from './utils';
import * as Devices from '../devices';
import { criterionNames } from '../../interfaces';

export const FilterCriteriaDefault: FilterCriteria = {
  orderNumber: '',
  deviceStatus: Devices.Statuses.Active,
  userOrders: true,
};

export const SelectionDefault: DT.ItemSelection<Order> = {
  isAllSelected: false,
  selectedKeys: [],
  getPK,
};

export const DataDefault: DT.IData<Order> = {
  pages: [],
  pageSize: 50,
  total: 0,
  version: 0,
  // totalsByType: Devices.TotalsByTypeDefault
};

export const TablePaginationDefault: DT.TablePagination = {
  currentPage: 1,
  numPages: 1,
  pageSize: 15,
};

export const TableDefault: DT.ITable<Order> = {
  content: [],
  isLoading: false,
  pagination: TablePaginationDefault,
  columns: [],
};

export const SortDefault: SortingRule = {
  id: criterionNames.orderNumber,
  desc: true,
};

export const StateDefault: State = {
  filters: FilterCriteriaDefault,
  sort: [SortDefault],
  selection: SelectionDefault,
  data: DataDefault,
  table: TableDefault,
  pagesToLoad: [1],
};
